import React from 'react'

import BloomIcon from '../../../assets/bloom-favicon.svg?react'

type Props = { color?: 'deep-green' | 'white' }
const PartnerIcon:React.FC<Props> = ({ color = 'deep-green' }) => {
  return (
    <div className='flex flex-col items-center'>
      <BloomIcon width={30} height={30} className={`fill-${color}`} />
      <p className={`text-3xs text-${color}`}>Partner</p>
    </div>
  )
}

export default PartnerIcon
